"use client";

import Script from "next/script";
import { googleAnalyticsId, scriptarioAnalyticsMode } from "@/lib/config";

export function GoogleAnalytics() {
  if (!googleAnalyticsId || scriptarioAnalyticsMode !== "ga4") return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${googleAnalyticsId}', { send_page_view: false });
        `}
      </Script>
    </>
  );
}
